import type { actionComponent, actionType } from '../components/reusable/right-panel/utils';
import { type PreloadableComponent, ReactLazyPreload } from '../routes/route-component';

export const rightSectionComponentMap = {
	'user-activity': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/user-activity/View')),
		},
	],
	'agent-coverage-detail': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/agent-coverage/Detail')),
		},
	],
	'irev-reference': [
		{
			action: ['update'],
			component: ReactLazyPreload(async () => await import('../right-panel/election/Add.Irev.Reference')),
		},
	],
	'irev-extraction-detail': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/irev-extraction/Detail')),
		},
	],
	'api-key-management': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/api-key/Create')),
		},
	],
	'api-key-rotate': [
		{
			action: ['update'],
			component: ReactLazyPreload(async () => await import('../right-panel/api-key/Rotate')),
		},
	],
	'api-key-detail': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/api-key/Detail')),
		},
	],
	'api-key-integration': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/api-key/Integration')),
		},
	],
	'service-registry-create': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/service-registry/Create')),
		},
	],
	'service-registry-detail': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/service-registry/Detail')),
		},
	],
	'team-access-invite': [
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/team-access/Invite')),
		},
	],
	'team-access-member': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/team-access/Member')),
		},
	],
	'team-access-bulk': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/team-access/BulkInvite')),
		},
	],
	// Independent Supporter accounts (team access P4).
	'team-access-supporter': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/team-access/Supporter')),
		},
	],
	'team-access-supporter-create': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/team-access/CreateSupporter')),
		},
	],
	'team-access-supporter-bulk': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/team-access/BulkSupporters')),
		},
	],
	'my-team-request': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/my-team/Request')),
		},
	],
	'help-context': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/help-centre/HelpContext')),
		},
	],
	'election-category': [
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/election-category/Create')),
		},
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/election-category/View')),
		},
	],
	'election-type': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/election-type/View')),
		},
	],
	'notification': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/notification/View')),
		},
	],
	'election-attribute': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/election-attribute/View')),
		},
		{
			action: ['update', 'create'],
			component: ReactLazyPreload(async () => await import('../right-panel/election-attribute/Create.Update')),
		},
	],
	'ed-in-ward': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/ward/Electoral.Division')),
		},
	],
	'ed-in-lga': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/lga/Electoral.Division')),
		},
	],
	'ed-in-constituency': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/constituency/Electoral.Division')),
		},
	],
	'ed-in-state': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/state/Electoral.Division')),
		},
	],
	'lga-constituency': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/constituency/Lga.Ward')),
		},
	],
	'ward-constituency': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/constituency/Lga.Ward')),
		},
	],
	'result-subscription-type': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/subscription/View.Type')),
		},
	],
	'electoral-division': [
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/electoral-division/Create.Update')),
		},
	],
	'pu-details': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/polling-units/View')),
		},
	],
	'lga-details': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/lga/View')),
		},
	],
	'constituency-details': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/constituency/View')),
		},
	],
	'constituency-mapping': [
		{
			action: ['update'],
			component: ReactLazyPreload(async () => await import('../right-panel/constituency/Mapping')),
		},
	],
	'state-details': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/state/View')),
		},
	],
	'ward-details': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/ward/View')),
		},
	],
	'ra-bulk-delete': [
		{
			action: ['delete'],
			component: ReactLazyPreload(async () => await import('../right-panel/result-analytics/BulkDelete')),
		},
	],
	'zone': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/zone/Create')),
		},
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/zone/View')),
		},
	],
	'election-selection': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/subscription/Select.Election')),
		},
	],
	'subscriptions': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/subscription/View')),
		},
	],
	'user': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/user/View')),
		},
		{
			action: ['delete'],
			component: ReactLazyPreload(async () => await import('../right-panel/user/Delete')),
		},
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/user/Create.Update')),
		},
	],
	'result-subscription': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/subscription/Add')),
		},
	],
	'view-audit-trail': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/audit-trail/View')),
		},
	],
	'user-audit-trail': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/audit-trail/View.Activities')),
		},
	],
	'send-email-result': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/election-result/Send.Mail')),
		},
	],
	'advanced-filter': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/election-result/Advanced.Filter')),
		},
	],
	'generate-election-result': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/election-result/Select.Result.Type')),
		},
	],
	'user-search-filter': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/result-assignment/Filter.Section')),
		},
	],
	'political-party': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/political-party/View')),
		},
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/political-party/Create')),
		},
	],
	'report-feedback-item': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/reports/View')),
		},
	],
	'side-menu-mobile': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/menu/Mobile.View')),
		},
	],
	'preview-media-file': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/election-result/upload/Preview.Media')),
		},
	],
	'upload-election-result': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/election-result/upload/Create')),
		},
	],
	'bulk-election-official-assignment': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/result-assignment/Bulk')),
		},
	],
	'election': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/election/View')),
		},
		{
			action: ['update'],
			component: ReactLazyPreload(async () => await import('../right-panel/election/Update')),
		},
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/election/Create')),
		},
	],
	'management-action': [
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/role-action/Create')),
		},
	],
	'management-roles': [
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/role/Create')),
		},
	],
	// F2.01/F2.02 — role detail panel (read-only summary + Compare CTA + Manage Actions).
	'role-detail': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/role/Detail')),
		},
	],
	// F5.04 — role-action detail panel (read-only summary + "Used by N roles" + Edit / Manage Roles).
	'role-action-detail': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/role-action/Detail')),
		},
	],
	// Sync the backend Action catalogue with the frontend ACTIONS permission set
	// (bulk-create missing codes + assign to admin roles).
	'sync-role-actions': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/role-action/SyncCatalogue')),
		},
	],
	// F2.04/F2.05 — side-by-side action diff between two roles.
	'role-compare': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/role/Compare')),
		},
	],
	// F2.07/F2.08/F2.09 — bulk user operations (4-phase pattern from BulkApprove).
	'user-bulk-suspend': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/user/BulkSuspend')),
		},
	],
	'user-bulk-activate': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/user/BulkActivateUser')),
		},
	],
	'user-bulk-assign-role': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/user/BulkAssignRole')),
		},
	],
	'assign-action-roles': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/role-action/Management')),
		},
	],
	'assign-actions-role': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/role/Action.Management')),
		},
	],
	'quick-actions': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/quick-action/Create')),
		},
	],
	'manage-election-officer': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/result-assignment/ResultAssignmentManagement')),
		},
	],
	'user-role': [
		{
			action: ['update'],
			component: ReactLazyPreload(async () => await import('../right-panel/role/Update')),
		},
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/role/Role.Management')),
		},
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/role/View')),
		},
	],
	'election-result': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/election-result/View')),
		},
	],
	'ra-result-detail': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/result-analytics/ResultDetail')),
		},
	],
	'party-breakdown': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/result-analytics/PartyBreakdown')),
		},
	],
	'analyst-bucket-activity': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/analyst-performance/BucketActivity')),
		},
	],
	'rv-quick-verdict': [
		{
			action: ['view', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/result-verification/QuickVerdict')),
		},
	],
	'result-audit-entity': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/result-audit/EntityPanel')),
		},
	],
	'rv-bulk-verdict': [
		{
			action: ['update'],
			component: ReactLazyPreload(async () => await import('../right-panel/result-verification/BulkVerdict')),
		},
	],
	'rv-update-register': [
		{
			action: ['update'],
			component: ReactLazyPreload(async () => await import('../right-panel/result-verification/UpdateRegister')),
		},
	],
	'rv-agent-presence': [
		{
			action: ['update'],
			component: ReactLazyPreload(async () => await import('../right-panel/result-verification/AgentPresence')),
		},
	],
	'assign-election-officer': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/result-assignment/Single')),
		},
	],
	'organization': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/organization/Organization.Add')),
		},
	],
	'whatsapp-test': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/whatsapp-test')),
		},
	],
	'media-gallery-picker': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/media-gallery/Picker')),
		},
	],
	'media-gallery-detail': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/media-gallery/Detail')),
		},
	],
	'media-gallery-upload': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/media-gallery/UploadDesk')),
		},
	],
	'contact': [
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/contacts/Create.Update')),
		},
	],
	'contact-bulk-add': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/contacts/BulkAdd')),
		},
	],
	'contact-sharing': [
		{
			action: ['update', 'view'],
			component: ReactLazyPreload(async () => await import('../right-panel/contacts/Sharing')),
		},
	],
	'contact-list': [
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/contacts/ListForm')),
		},
	],
	'contact-add-to-list': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/contacts/AddToList')),
		},
	],
	'voter': [
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/voters/Create.Update')),
		},
	],
	'voter-detail': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/voters/Detail')),
		},
	],
	'voter-import-batch': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/voters/ImportBatch')),
		},
	],
	'candidate-record': [
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/candidate-record/Create.Update')),
		},
	],
	'candidate-record-view': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/candidate-record/Detail')),
		},
	],
	'election-observer': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/election-observer/View')),
		},
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/election-observer/Create.Update')),
		},
	],
	'observer-register-elections': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/election-observer/RegisterElections')),
		},
	],
	'agent': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/agents/View')),
		},
	],
	'observer-volunteer': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/observer-volunteer/View')),
		},
	],
	'observer-applications': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/observer-applications/List')),
		},
	],
	'observer-bulk-assign': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/observer-applications/BulkAssign')),
		},
	],
	'observer-create-state': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/observer-applications/CreateStateObserver')),
		},
	],
	'assign-candidate': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/candidate/AssignCandidate')),
		},
	],
	'assign-election': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/candidate/AssignElection')),
		},
	],
	'assign-agent': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/agents/Assign')),
		},
	],
	'create-state-agent': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/agents/CreateStateAgent')),
		},
	],
	'priority-units': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/agents/PriorityUnits')),
		},
	],
	'trusted-agent-invite': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/trusted-agent/InviteTrustedAgent')),
		},
	],
	'trusted-agent-invitations': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/trusted-agent/InvitationsList')),
		},
	],
	'view-stats': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/stats/View')),
		},
	],
	'manage-party-agent-assignment': [
		{
			action: ['create', 'view'],
			component: ReactLazyPreload(async () => await import('../right-panel/party-agent-assignment/ManageAssignment')),
		},
	],
	'vesr-incident': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/vesr/incident/View')),
		},
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/vesr/incident/Create.Update')),
		},
	],
	'vesr-incident-list': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/vesr/incident/List')),
		},
	],
	'vesr-election-pulse': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/vesr/election-pulse/View')),
		},
	],
	'coupon-service': [
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/coupons/Create.Update')),
		},
	],
	'broadcast-coupon': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/coupons/Broadcast')),
		},
	],
	'coupon-schedules': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/coupons/Schedules')),
		},
		{
			action: ['update'],
			component: ReactLazyPreload(async () => await import('../right-panel/coupons/ScheduleEdit')),
		},
	],
	'service-rate': [
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/service-rates/Create.Update')),
		},
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/service-rates/History')),
		},
	],
	'wallet-transaction': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/wallet-transaction/View')),
		},
	],
	'wallet-topup': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/wallet-transaction/topup')),
		},
	],
	'admin-wallet-detail': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../app/system-management/wallets/WalletDetail')),
		},
	],
	'message-template': [
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/message-template/Editor')),
		},
	],
	'coupon-rewards': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/coupons/Rewards')),
		},
	],
	'agent-bulk-approve': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/agents/BulkApprove')),
		},
	],
	'agent-bulk-trust': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/agents/BulkTrust')),
		},
	],
	'ed-bulk-assign': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/agents/BulkAssign')),
		},
	],

	'bulk-assign-election': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/user/BulkAssignElection')),
		},
	],

	'feedback-item': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/feedback/View')),
		},
	],
	'message-queue': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/voter-interaction/message-queue')),
		},
	],
	'message-transactions': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/voter-interaction/message-transactions')),
		},
	],
	'lms-course-detail': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/lms/CourseDetail')),
		},
	],
	'lms-course': [
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/lms/CourseForm')),
		},
	],
	'lms-module': [
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/lms/ModuleForm')),
		},
	],
	'lms-lesson': [
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/lms/LessonForm')),
		},
	],
	'legal-document-type': [
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/legal/DocumentTypeCreate.Update')),
		},
	],
	'legal-document': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/legal/DocumentView')),
		},
		{
			action: ['create', 'update'],
			component: ReactLazyPreload(async () => await import('../right-panel/legal/DocumentPublish')),
		},
	],
	'legal-consent-view': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/legal/ConsentView')),
		},
	],
	'registration-customization': [
		{
			action: ['update', 'create'],
			component: ReactLazyPreload(async () => await import('../right-panel/political-party/RegistrationCustomization')),
		},
	],
	'stronghold-editor': [
		{
			action: ['update', 'create'],
			component: ReactLazyPreload(async () => await import('../right-panel/live-election/StrongholdEditor')),
		},
	],
	'strong-hold-settings': [
		{
			action: ['update', 'view'],
			component: ReactLazyPreload(async () => await import('../right-panel/strong-hold/PlanSettings')),
		},
	],
	'strong-hold-history': [
		{
			action: ['update', 'view'],
			component: ReactLazyPreload(async () => await import('../right-panel/strong-hold/History')),
		},
	],
	'cancellation-detail': [
		{
			action: ['view'],
			component: ReactLazyPreload(async () => await import('../right-panel/cancellations/Detail')),
		},
	],
	'cancellation-bulk-entry': [
		{
			action: ['create'],
			component: ReactLazyPreload(async () => await import('../right-panel/cancellations/BulkEntry')),
		},
	],
	'cancellation-notify-settings': [
		{
			action: ['update', 'view'],
			component: ReactLazyPreload(async () => await import('../right-panel/cancellations/NotifySettings')),
		},
	],
	'strong-hold-copy': [
		{
			action: ['update', 'create'],
			component: ReactLazyPreload(async () => await import('../right-panel/strong-hold/CopyFromElection')),
		},
	],
} as Partial<
	Record<
		actionComponent,
		{
			action: actionType[];
			component: PreloadableComponent<() => JSX.Element>;
		}[]
	>
>;
